export default class DtoBoreholeComment {
    constructor(obj) {
        this.idStation = obj.idStation
        this.order = obj.order
        this.depth = obj.depth
        this.comment = obj.comment
        this.headers = ['order', 'comment', 'depth']
    }
}